export function uniqFilter(): (value: unknown) => boolean {
    const seen = new Set<unknown>();

    return (value: unknown) => {
        if (seen.has(value)) {
            return false;
        }

        seen.add(value);

        return true;
    };
}

export function uniqWithFilter<T>(
    getKey: (value: T) => unknown,
): (value: T) => boolean {
    const seen = new Set<unknown>();

    return (value: T) => {
        const key = getKey(value);

        if (seen.has(key)) {
            return false;
        }

        seen.add(key);

        return true;
    };
}
